class GiftEngine extends HTMLElement {
    constructor() {
        super();
        this.selects = this.querySelectorAll("custom-select");
        this.gauge = this.querySelector("budget-gauge");
        this.button = this.querySelector(".gift-engine-button");
        this.collectionURL = '';
        this.tag = '';
        this.valueToAppends = '';
        this.filters = '';
    }

    connectedCallback() {
        this.button.addEventListener("click", () => {
            this.selects.forEach(select => {
                const selectDataType = select.dataset.name;
                const selectOption = this.getSelectedOption(select);
                if (selectDataType === "target") {
                    let tag = selectOption.dataset.tag;
                    let collection = selectOption.dataset.collection;
                    if (collection)
                        this.collectionURL = collection;
                    else
                        this.tag = tag;
                }
                if (selectDataType === "opportunity") {
                    let tag = selectOption.dataset.tag;
                    let collection = selectOption.dataset.collection;
                    if (collection)
                        this.collectionURL = collection;
                    else
                        this.tag = tag;
                }
                if (selectDataType === "profil") {
                    let tag = selectOption.dataset.tag;
                    tag = tag.replace(' ', '+');
                    this.valueToAppends += `&filter.p.m.custom.profil=${tag}`;
                }
            });
            if (this.gauge) {
                const value1 = this.gauge.querySelector(".curseur-bas").dataset.value;
                const value2 = this.gauge.querySelector(".curseur-haut").dataset.value;
                this.valueToAppends += `&filter.v.price.gte=${value1}` + value2 != null ? `&filter.v.price.gte=${value1}&filter.v.price.lte=${value2}` : null;
            }
            location.href = (this.collectionURL ? this.collectionURL : '/collections/tous-les-produits') + '/' + this.tag + (this.valueToAppends ? '?sort_by=manual' + this.valueToAppends : '');
        });
    }

    getSelectedOption(selectElement) {
        return selectElement.querySelector('.selected-option');
    }
}

customElements.define("gift-engine", GiftEngine);

class CustomSelect extends HTMLElement {
    constructor() {
        super();
        this.selectedOption = this.querySelector('.selected-option');
        this.selectOptions = this.querySelector('.options');
        this.optionItems = this.querySelectorAll('.option');
        this.maxWidth = 0;

        this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);

        document.addEventListener('click', (e) => {
            if (!this.contains(e.target)) {
                this.selectOptions.style.display = 'none';
                this.classList.remove('active');
            }
        });

        this.selectedOption.addEventListener('click', () => {
            this.selectOptions.style.display = this.selectOptions.style.display === 'block' ? 'none' : 'block';
            this.selectOptions.style.display === 'block' ? this.classList.add('active') : this.classList.remove('active');
        });

        this.optionItems.forEach((option) => {
            option.addEventListener('click', () => {
                const arrowContainer = this.selectedOption.querySelector('.arrow-down-container');

                while (this.selectedOption.firstChild) {
                    this.selectedOption.removeChild(this.selectedOption.firstChild);
                }

                const optionContent = option.innerHTML;

                this.selectedOption.innerHTML = optionContent;
                this.selectedOption.appendChild(arrowContainer);

                this.selectOptions.style.display = 'none';
                this.classList.remove('active');
                const selectedTag = option.getAttribute('data-tag');
                const selectedCollection = option.getAttribute('data-collection');
                this.selectedOption.setAttribute('data-tag', selectedTag);
                this.selectedOption.setAttribute('data-collection', selectedCollection);

                const selectedImage = option.querySelector('img');
                const selectedImageSrc = selectedImage ? selectedImage.getAttribute('src') : '';
                const selectedImageAlt = selectedImage ? selectedImage.getAttribute('alt') : '';
                const selectedImageElement = this.selectedOption.querySelector('img');
                if (selectedImageElement) {
                    selectedImageElement.setAttribute('src', selectedImageSrc);
                    selectedImageElement.setAttribute('alt', selectedImageAlt);
                }
            });
        });
    }

    handleResize() {
        if (window.innerWidth < 768) {
            this.style.width = '100%';
        } else {
            this.selectOptions.style.display = 'block';
            this.maxWidth = this.selectOptions.getBoundingClientRect().width + 30;
            this.style.width = `${this.maxWidth}px`;
            this.selectOptions.style.display = 'none';
        }
    }
}


customElements.define("custom-select", CustomSelect);

class BudgetGauge extends HTMLElement {
    constructor() {
        super();
        this.curseurBas = this.querySelector('#curseurBas');
        this.curseurHaut = this.querySelector('#curseurHaut');
        this.overlayBas = this.querySelector('#overlayBas');
        this.overlayHaut = this.querySelector('#overlayHaut');
        this.etapes = [
            { position: 2, value: 0 },
            { position: 20, value: 10 },
            { position: 40, value: 20 },
            { position: 60, value: 50 },
            { position: 80, value: 100 },
            { position: 98, value: null }
        ];
        this.marqueurElements = this.querySelectorAll('.marqueur-value');

        this.curseurBas.addEventListener('mousedown', this.startDragging);
        this.curseurHaut.addEventListener('mousedown', this.startDragging);

        this.curseurBas.addEventListener('touchstart', this.startDragging);
        this.curseurHaut.addEventListener('touchstart', this.startDragging);
    }

    startDragging = (e) => {
        e.preventDefault();

        const curseur = e.target;
        const jaugeRect = this.getBoundingClientRect();

        let decalageInitial;
        if (e.touches && e.touches.length > 0) {
            decalageInitial = e.touches[0].clientX - curseur.getBoundingClientRect().left;
        } else {
            decalageInitial = e.clientX - curseur.getBoundingClientRect().left;
        }

        const drag = (e) => {
            let newPosition;
            if (e.touches && e.touches.length > 0) {
                newPosition = e.touches[0].clientX - jaugeRect.left - decalageInitial;
            } else {
                newPosition = e.clientX - jaugeRect.left - decalageInitial;
            }

            newPosition = Math.min(Math.max(0, newPosition), jaugeRect.width - curseur.offsetWidth);

            const newPositionPercentage = (newPosition / (jaugeRect.width - curseur.offsetWidth)) * 100;

            let index = Math.round((newPositionPercentage * (this.etapes.length - 1)) / 100);
            index = Math.min(Math.max(index, 0), this.etapes.length - 1);

            const currentValue = this.etapes[index].value;
            const currentPosition = this.etapes[index].position;

            curseur.style.left = `${(currentPosition / this.etapes[this.etapes.length - 1].position) * 100}%`;

            if (curseur == this.curseurBas)
                this.overlayBas.style.width = `${(currentPosition / this.etapes[this.etapes.length - 1].position) * 100}%`;
            else
                this.overlayHaut.style.width = `${100 - ((currentPosition / this.etapes[this.etapes.length - 1].position) * 100)}%`;

            curseur.dataset.value = currentValue !== null ? currentValue : 'null';

            this.marqueurElements.forEach(marqueur => {
                const marqueurValue = marqueur.dataset.value;
                const currentValueInt = currentValue === "null" ? null : currentValue;
                const marqueurValueInt = marqueurValue === "null" ? null : parseInt(marqueurValue);
                const autreMarqueur = curseur == this.curseurBas ? this.curseurHaut : this.curseurBas;
                const autreMarqueurValue = autreMarqueur.dataset.value === "null" ? null : parseInt(autreMarqueur.dataset.value);

                if (marqueurValueInt === currentValueInt) {
                    marqueur.classList.add('active');
                } else {
                    if (marqueurValueInt !== autreMarqueurValue)
                        marqueur.classList.remove('active');
                }
            });
        };

        const endDrag = () => {
            document.removeEventListener('mousemove', drag);
            document.removeEventListener('mouseup', endDrag);
            document.removeEventListener('touchmove', drag);
            document.removeEventListener('touchend', endDrag);
        };

        document.addEventListener('mousemove', drag);
        document.addEventListener('mouseup', endDrag);
        document.addEventListener('touchmove', drag);
        document.addEventListener('touchend', endDrag);
    };


    getPosition(event) {
        const jaugeRect = this.getBoundingClientRect();
        if (event.touches && event.touches.length > 0) {
            return event.touches[0].clientX - jaugeRect.left;
        } else {
            return event.clientX - jaugeRect.left;
        }
    }
}

customElements.define("budget-gauge", BudgetGauge);
